


  export default  class  LeadRemainderStatus {  public static readonly Pending = new LeadRemainderStatus('Pending','Pending',0) ;
  public static readonly Completed = new LeadRemainderStatus('Completed','Completed',1) ;
  public static readonly Cancelled = new LeadRemainderStatus('Cancelled','Cancelled',2) ;
  private _ident: string ;
  private _name: string ;
  private _index: number ;
 public constructor ( _ident : string,_name : string,_index : number ) {
 this._ident=_ident;

this._name=_name;

this._index=_index;
 }
  public static get values (  ) : LeadRemainderStatus[] {
 return [ LeadRemainderStatus.Pending, LeadRemainderStatus.Completed, LeadRemainderStatus.Cancelled ] ; 
 }
  public get ident (  ) : string {
 return this._ident ; 
 }
  public get name (  ) : string {
 return this._name ; 
 }
  public get index (  ) : number {
 return this._index ; 
 }
  public toString (  ) : string {
 return this._name ; 
 }
 }